import { useState, useEffect } from "react";

// Save as: src/hooks/useAuth.js

export const AUTH_EVENT = "ftthsa-auth-changed";

const readAuth = () => {
  try {
    return !!localStorage.getItem("accessToken");
  } catch {
    return false; // private mode / blocked storage
  }
};

// Call this after anything that changes login state (login, logout, token expiry)
export const notifyAuthChanged = () => {
  window.dispatchEvent(new Event(AUTH_EVENT));
};

export const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(readAuth);

  useEffect(() => {
    const sync = () => setIsLoggedIn(readAuth());

    window.addEventListener(AUTH_EVENT, sync); // same tab
    window.addEventListener("storage", sync); // other tabs
    sync(); // catch anything that changed before we subscribed

    return () => {
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return { isLoggedIn };
};